import request from '@/utils/request'

// 查询会议室设备
export function searchEquipment(query) {
  return request({
    url: '/equipment/search',
    method: 'post',
    data: query
  })
}
// 新增会议室设备
export function addEquipment(query) {
  return request({
    url: '/equipment',
    method: 'post',
    data: query
  })
}
// bainji会议室设备
export function editEquipment(query) {
  return request({
    url: '/equipment/edit/' + query.id,
    method: 'post',
    data: query
  })
}
